var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoggy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 451,
    height: 386,
    fill: "none",
    viewBox: "0 0 451 386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_38_902)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 223.598,
    cy: 150,
    r: 150,
    fill: "url(#paint0_linear_38_902)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint1_linear_38_902)",
    strokeLinecap: "round",
    strokeWidth: 27.713,
    d: "M17 248.146C87 231.006 157 231.006 227 248.146C297 265.285 367 265.285 437 248.146"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint2_linear_38_902)",
    strokeLinecap: "round",
    strokeWidth: 27.713,
    d: "M14 304.854C84 287.715 154 287.715 224 304.854C294 321.993 364 321.993 434 304.854"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint3_linear_38_902)",
    strokeLinecap: "round",
    strokeWidth: 27.713,
    d: "M14 358.854C84 341.715 154 341.715 224 358.854C294 375.993 364 375.993 434 358.854"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_38_902",
    width: 300,
    height: 321.124,
    x: 73.597,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.124
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.967
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "overlay",
    result: "effect1_innerShadow_38_902"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_902",
    x1: 223.598,
    x2: 223.598,
    y1: 0,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_902",
    x1: -9.5,
    x2: 420.5,
    y1: 235,
    y2: 261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_902",
    x1: -12.5,
    x2: 417.5,
    y1: 291.709,
    y2: 317.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_902",
    x1: -12.5,
    x2: 417.5,
    y1: 345.709,
    y2: 371.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCFCF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoggy);
export default __webpack_public_path__ + "static/media/foggy.62ae602a36128aadd9c319d532cff6ed.svg";
export { ForwardRef as ReactComponent };